export const apiErrorDetail = (error: unknown): string | null => {
    if (error === null || typeof error !== "object") return null;
    const { detail } = error as { detail?: unknown };
    return typeof detail === "string" ? detail : null;
};

export const apiErrorStrings = (error: unknown): string[] => {
    if (error === null || typeof error !== "object") return [];
    const { detail, message } = error as {
        detail?: unknown;
        message?: unknown;
    };
    return [detail, message].filter(value => typeof value === "string");
};
